import React from 'react';
import * as Backend from "../backend.js";
import * as util from "../other/util.js";
import { GameData } from "../share/game-data.js";

// Shows the message history for a particular conversation
class ChatView extends util.GameComponent {
    constructor(props) {
        super(props);

        this.state = {};

        Backend.getPlayerChatDetails(this.props.params.chat_id, (res) => {
            this.setState({
                chat: res.chat,
            });
        });
    }

    render() {
        let chat = this.state.chat;
        if (!chat) {
            return (<util.LoadingBar thing={chat} thingName="chat" />);
        }

        return (
            <div>
                <h1>Conversation Details</h1>

                {/* Meta */}
                <div>
                    <span className="boring-info-text">Subject:</span> {chat.subject}
                </div>
                <div>
                    <span className="boring-info-text">Initiator: </span>
                    {this.renderPlayerName(chat.initiator_id, chat.initiator_name)}
                </div>
                <div>
                    <span className="boring-info-text">Participants: </span>
                    {chat.player_names.map((name, idx) => (<span key={idx}> {this.renderParticipant(idx)}</span>))}
                </div>

                {/* Reply */}
                {this._renderReplyField(chat)}

                {/* Messages */}
                {chat.messages.slice(0).reverse().map((message, idx) => (this.renderMessage(idx, message)))}

                {/* Debug */}
                <util.JsonDebug obj={chat} />
            </div>
        );
    }

    renderParticipant(idx) {
        let player_id = this.state.chat.player_ids[idx];
        let player_name = this.state.chat.player_names[idx];
        return this.renderPlayerName(player_id, player_name);
    }

    renderPlayerName(player_id, player_name) {
        if (player_id === -1) {
            return (
                <span key={player_id}>{player_name}</span>
            )
        } else {
            return (
                <util.PlayerLink key={player_id} playerId={player_id} playerName={player_name} />
            )
        }
    }

    renderMessage(idx, message) {
        if (message.details) {
            return (<FleetMessage key={idx} message={message} />);
        } else {
            return (<HumanMessage key={idx} message={message} />);
        }
    }

    _renderReplyField(chat) {
        if (chat.initiator_id === -1) {
            return;
        }

        return (
            <div>
                <h3>Reply</h3>
                <textarea value={this.state.content}
                    placeholder="Message content" maxLength="131072" rows="5" cols="120"
                    onChange={(event) => {
                        if (event.target.value.length <= 131072) {
                            this.setState(Object.assign({}, this.state, { content: event.target.value }));
                        }
                    }}
                    onKeyPress={(event) => {
                        if (event.ctrlKey && event.key === "Enter") {
                            this.handleSendClick();
                        }
                        return false;
                    }}
                />
                <br />
                <button className="cool-button" onClick={() => {
                    this.handleSendClick();
                }}> Send !
                </button>
            </div>);
    }

    handleSendClick() {
        if (!this.state.content) { return; }

        Backend.tryChatMessage(
            this.state.chat.id,
            this.state.content,
            (res) => {
                this.handleServerResponsesForSendingMessage(res);
            });
    }

    handleServerResponsesForSendingMessage(res) {
        if (res.success) {
            this.setState({ chat: res.chat, content: "" });
        }
    }
}

class HumanMessage extends React.Component {
    render() {
        let message = this.props.message;
        if (!message.content) message.content = "";
        let content = message.content.split('\n').map((item, i) => {
            return <p key={i}>{item}</p>;
        });

        return (
            <div>
                <h3>{message.sender_name}</h3>
                <span className="boring-info-text"
                    style={{ float: "right" }}>Received: {new Date(message.time_stamp).toLocaleString()}</span>
                <div>{content}</div>
            </div>
        );
    }
}

class FleetMessage extends React.Component {
    render() {
        let message = this.props.message;

        let str = GameData.FLEET_STEPS[message.details.type].content;
        let content = util.smartTextToHtml(str, message.details);
        return (
            <div style={{ margin: "20px" }}>
                <span className="boring-info-text">{new Date(message.time_stamp).toLocaleString()}:</span>
                <div>{content}</div>
            </div>
        );
    }
}

export default util.withParams(ChatView);